import { useEffect, useState } from "react";

function scrollToWaitlist() {
  const el = document.getElementById("waitlist");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Navbar({ taken, cap }) {
  const [time, setTime] = useState("");

  useEffect(() => {
    const fmt = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#171512]/10 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        <a data-testid="navbar-brand-logo" href="/" className="font-serif text-2xl italic leading-none text-[#171512]">
          nostos
        </a>
        <div className="flex items-center gap-5">
          <span
            data-testid="navbar-ist-time"
            className="hidden font-mono text-[11px] tracking-[0.2em] text-[#171512]/45 sm:block"
          >
            {time} IST
          </span>
          <span
            data-testid="navbar-founding-status"
            className="hidden font-mono text-[11px] tracking-[0.2em] text-[#B9822E] md:block"
          >
            {taken == null ? "--" : taken.toLocaleString("en-IN")}/{cap.toLocaleString("en-IN")} FOUNDING
          </span>
          <button
            data-testid="navbar-join-button"
            onClick={scrollToWaitlist}
            className="rounded-full bg-[#171512] px-4 py-2 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[#F8F4ED] transition-colors duration-200 hover:bg-[#F5C7D4] hover:text-[#171512]"
          >
            join now
          </button>
        </div>
      </div>
    </header>
  );
}
